/* Replace shop buttons with call button */



$('.pdpSectionWithNav').each(function() {
    // Cache selectors
    var $this = $(this),
    _this = this,
    lastId,
    topMenu = $this.find('.pdpSectionWithNav__nav'),
    topMenuHeight = topMenu.outerHeight(),
    // All list items
    menuItems = topMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
    });

    // Bind click handler to menu items
    // so we can get a fancy scroll animation
    menuItems.click(function(e){
        // Get header height
        var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height').slice(0, -2));
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight - headerHeight + 1;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 0);
        history.pushState(null, null, href);
        e.preventDefault();
    });

    // Bind to scroll
    $(window).scroll(function() {
        // Get header height
        var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height').slice(0, -2));
        // Get container scroll position
        var fromTop = $(this).scrollTop() + topMenuHeight + headerHeight;

        // Get id of current scroll item
        var cur = scrollItems.map(function(index) {
            if ($(this).offset().top < fromTop + $(window).height() * 0.2)
                return this;
            if (index === 0 && $(this).offset().top < fromTop + $(window).height())
                return this;
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";
        
        if (lastId !== id) {
            lastId = id;
            // Set/remove active class
            menuItems.removeClass("active").filter("[href='#"+id+"']").addClass("active");

            // We animate to move the active item
            var scrollX =
              menuItems.filter(".active")[0].offsetLeft -
              (topMenu.closest('.pdpSectionWithNav__navWrapper').innerWidth() -
                menuItems.filter(".active").innerWidth()) /
                2;
                console.log(menuItems.filter(".active")[0].offsetLeft, topMenu.closest('.pdpSectionWithNav__navWrapper').innerWidth())
            topMenu.closest('.pdpSectionWithNav__navWrapper').animate({
              scrollLeft: scrollX,
            }, 0);
        }                   
    });
});

$(window).on('load', function() {
    var url = window.location.href;
    var idx = url.indexOf("#");
    var hash = idx !== -1 ? url.substring(idx + 1) : "";

    if (hash) {
        setTimeout(function() {
            var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height').slice(0, -2)) || 0;
            var topMenuHeight = $('.pdpSectionWithNav__nav').outerHeight() || 0;

            var element = $('#' + hash);
            if (element.length) {
                var offsetTop = element.offset().top - topMenuHeight - headerHeight - 60;

                $('html, body').stop().animate({ 
                    scrollTop: offsetTop
                }, 500);
            }
        }, 100);
    }
});

// Function to handle scrolling with offset
function scrollToAnchor(anchor) {
    var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height').slice(0, -2)) || 0;
    var offsetTop = $(anchor).offset().top - headerHeight - 20; // Adjust the -20 value as needed for extra spacing

    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
}

// Bind click handler to anchor-offset links
$('a.anchor-offset').click(function(e) {
    var href = $(this).attr("href");
    if (href.startsWith("#")) {
        e.preventDefault();
        scrollToAnchor(href);
        history.pushState(null, null, href);
    }
});

document.querySelectorAll('.read-more').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        var hrefVal = this.getAttribute('href');
        var splitVal = hrefVal.split("#");
        var reqId = splitVal[1];
        var element = document.getElementById(reqId);
        var headerOffset = document.getElementById('header').offsetHeight + 70;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
        window.scrollTo({
             top: offsetPosition,
             behavior: "smooth"
        });        
    });
});

/* Open external links in a new tab */
(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    var href = links[i].getAttribute('href');
    if (href === 'javascript:void(0)' || href.charAt(0) === '#') {
      // Do Nothing
    }
    else if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
})();


